import { mapGetters, mapActions } from 'vuex'
import TransactionsDetailedHeader from '../TransactionsDetailedHeader/index'

export default {
  name: 'PaymentHistory',
  components: { TransactionsDetailedHeader },
  props: [],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'totalPaymentsAvailable',
      'totalPaymentsFetched',
      'payments'
    ]),
    ...mapActions([
      'loadPayment'
    ])

  },
  mounted () {
      this.$store.dispatch('loadPayment', { startIndex:0, endIndex:2 })
      
      
  },
  methods: {

  },
  filters: {
    formatDate: function (value) {

      if (!value) return ''
      value = new Date(value)
      var monthArray = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let day = value.getDate(),
          month = monthArray[value.getMonth()],
          year = value.getFullYear()
      return day + " " + month + ", " + year
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/PaymentHistory/component.js